import { type ReactNode, useMemo } from 'react';
import { SnapshotService } from './snapshot-service';
import { SnapshotServiceContext } from './use-snapshot-service';
import { useYjsRegistry } from '@/lib/sync/hooks/yjs-registry-context';
import { useSyncSystem } from '@/lib/sync/sync-system-context';

export function SnapshotServiceProvider({ children }: { children: ReactNode }) {
  const registry = useYjsRegistry();
  const system = useSyncSystem();
  const service = useMemo(
    () => new SnapshotService((entityId) => registry.getDoc(entityId), system.opSync),
    [registry, system],
  );

  return (
    <SnapshotServiceContext.Provider value={service}>
      {children}
    </SnapshotServiceContext.Provider>
  );
}
